<template>
  	<section class="app-container">
		<div class="">
			
			<Articles />
			
			<UsageSummary />
			<InvoiceHomeCard />

			<div v-if="!loading" class="service-health-checker">
				<details>
					<summary>Services status</summary>
					<ServiceHealth
						v-for="(service, index) in downServices"
						:service="service"
						:key="index"
					/>
				</details>
			</div>
			<div v-if="loading" class="service-health-checker">
				<p class="service-health-checker-text">
					<svg style="fill: var(--clr-loader, var(--clr-neutral-shade-4, #babdbf));" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25"/><path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="spinner_z9k8"/></svg>	
					<span>Checking services ...</span>
				</p>
			</div>
			
			
		</div>
		<GitConfigDialog ref="gitConfigDialog" />
	</section>
</template>

<script>
import ServiceHealth from "./ServiceHealth.vue";
import Articles from "../articles/Articles"
import UsageSummary from "../usage/UsageSummary.vue";
import InvoiceHomeCard from "../invoice/InvoiceHomeCard";
import { mapGetters } from "vuex";
import GitConfigDialog from "../git-config/GitConfigDialog";

export default {
	name: "ConsoleDashboard",
	components: {
		ServiceHealth,
		UsageSummary,
		InvoiceHomeCard,
		Articles,
		GitConfigDialog
	},
	data(){
		return{
			importServiceName: null
		};
	},
	computed: {
		...mapGetters({
			downServices: 'downServices'
		}),
		loading: function () {
			return this.$store.getters.loading("service-health");
		},
		error: function () {
			return this.$store.getters.error("services");
		},
	},
	mounted(){
		if (this.$route.query.openImport) {
			this.$refs.gitConfigDialog.show("Upload", this.$route.query.openImport);
		}
	}
};
</script>

<style>.spinner_z9k8{transform-origin:center;animation:spinner_StKS .75s infinite linear}@keyframes spinner_StKS{100%{transform:rotate(360deg)}}</style>